export default "__VITE_ASSET__EM7PiFEG__"